import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { updateMerchant as updateMerchantApi } from "../api/merchant.api";
import type { MerchantDetail, UpdateMerchantAdminRequest } from "../types/merchant.types";

interface UseUpdateMerchantReturn {
  updateMerchant: (id: string, request: UpdateMerchantAdminRequest) => Promise<MerchantDetail>;
  loading: boolean;
  error: string | null;
}

export const useUpdateMerchant = (): UseUpdateMerchantReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateMerchant = useCallback(
    async (id: string, request: UpdateMerchantAdminRequest): Promise<MerchantDetail> => {
      try {
        setLoading(true);
        setError(null);
        return await updateMerchantApi(id, request);
      } catch (updateError: unknown) {
        setError(getApiErrorMessage(updateError, "Failed to update merchant"));
        throw updateError;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { updateMerchant, loading, error };
};
